import { Hero, NutritionInfoTable, TabGroup, TwoColumn } from '@/molecules';
import { Button, Modal, Text } from '@/atoms';
import { LinkVariant } from '@/atoms/link/types';
import { Container, Content01 } from '@/atoms';
import { Table, TraceabilityWithModule } from '@/organisms';
import Image from 'next/image';
import { ButtonVariant } from '@/atoms/button/types';
import Rating from '@/templates/rating';
import Layout from '@/components/layouts/Layout';
import { ProductBlockShopify } from '@/templates';

export function BridlePage({ blocks, theme, preFooter, meta, dataBridle, tabsHeaders, bridle, setPopUp, activoValoracion, setValorado, popUp, products, canonical }) {
    return (

        <>
            <Layout blocks={blocks} theme={theme ? 'dark' : 'light'} layoutType='base' preFooter={preFooter} meta={meta} canonical={canonical}>
                <Hero
                    align="items-center"
                    backgroundImage="/assets/quienes-somos-hero.png"
                    overlay={0.5}
                    textAlign="text-center"
                    theme="dark"
                    classNameWrapper="pt-header"
                >
                    <Hero.Pretitle key={1} position="center" theme="dark">
                        TRAZABILIDAD
                    </Hero.Pretitle>
                    <Hero.Title key={2} as="h1">
                        Asegurando la calidad y la garantía en nuestros productos.
                    </Hero.Title>
                    <Hero.Link href="#" variant={LinkVariant.NEGATIVE} key={3}>
                        Ver el orígen de mi producto
                    </Hero.Link>
                </Hero>
                <Container wrapper wrapperSize="max-w-[790px]">
                    <Content01
                        pretitle="Trazabilidad"
                        title="Información blockchain"
                        position="center"
                    />
                </Container>
                {dataBridle?.status === 'ok' && (
                    <Container wrapper>
                        <TabGroup tabs={tabsHeaders}>
                            <TwoColumn gap="gap-10 md:gap-20">
                                <TwoColumn.Left>
                                    <NutritionInfoTable title="Tipo de Pieza">
                                        <Table.Line
                                            name="Tipo Pieza"
                                            value={dataBridle?.data[0]?.DENOMINATION}
                                        />
                                        {dataBridle?.data[0]?.WEIGHT !== '' && (
                                            <Table.Line
                                                name="Peso"
                                                value={dataBridle.data[0]?.WEIGHT}
                                            />
                                        )}
                                        <Table.Line name="Raza" value={dataBridle.data[0]?.BREED} />
                                        <Table.Line
                                            name="Precinto"
                                            value={dataBridle.data[0]?.BRIDLE}
                                        />
                                    </NutritionInfoTable>
                                </TwoColumn.Left>
                                {dataBridle.data[0]?.PRODUCT_IMAGE ?
                                    <TwoColumn.Right className="w-full min-h-[385px] md:min-h-0 relative">
                                        <Image
                                            src={dataBridle.data[0]?.PRODUCT_IMAGE}
                                            width={150}
                                            height={400}
                                            className="mx-auto"
                                            alt="Imagen trazabilidiad"
                                        />
                                    </TwoColumn.Right> : undefined}
                            </TwoColumn>
                            <TwoColumn gap="gap-10 md:gap-20">
                                <TwoColumn.Left>
                                    <NutritionInfoTable title="Origen">
                                        <Table.Line name="Nacido y creado" value="España" />
                                        <Table.Line
                                            name="Informe de inspección"
                                            value={dataBridle.data[0]?.CERTIFIED_NUMBER}
                                        />
                                        {dataBridle.data[0]?.FARM_CERTIFIER !== '' && (
                                            <p className="text-body text-body--m text-primary-500 mt-5">
                                                Este producto procede de un cerdo Ibérico certificado
                                                por {dataBridle.data[0]?.FARM_CERTIFIER}
                                            </p>
                                        )}
                                    </NutritionInfoTable>
                                    <Text
                                        className="text-subtitle text-subtitle--l mb-8 mt-10"
                                        as="h2"
                                    >
                                        Ubicación del origen
                                    </Text>
                                    <p className="text-body text-body--l mb-4">
                                        {dataBridle.data[0]?.PLACE}
                                    </p>
                                </TwoColumn.Left>
                                {dataBridle.data[0]?.PLACE_IMAGE ?
                                    <TwoColumn.Right className="w-full min-h-[385px] md:min-h-0 relative">
                                        <Image
                                            src={dataBridle.data[0]?.PLACE_IMAGE}
                                            width="400"
                                            height={400}
                                            className="mx-auto"
                                            alt="Imagen trazabilidad"
                                        />
                                    </TwoColumn.Right> : undefined}
                            </TwoColumn>

                            <TwoColumn gap="gap-10 md:gap-20">
                                <TwoColumn.Left>
                                    <NutritionInfoTable title="Curación">
                                        <Table.Line
                                            name="Curado en"
                                            value={dataBridle.data[0]?.PLACE}
                                        />
                                        <Table.Line
                                            name="Tiempo de curación"
                                            value={dataBridle.data[0]?.ELABORATION_PERIOD}
                                        />
                                        <Table.Line name="Precinto" value={dataBridle.BRIDLE} />
                                    </NutritionInfoTable>
                                    {dataBridle.data[0]?.FARM_CERTIFIER !== '' && (
                                        <p className="text-body text-body--m text-primary-500 mt-5">
                                            Este producto procede de un cerdo Ibérico certificado por{' '}
                                            {dataBridle.data[0]?.FARM_CERTIFIER}
                                        </p>
                                    )}
                                    <Text
                                        className="text-subtitle text-subtitle--l mb-8 mt-10"
                                        as="h2"
                                    >
                                        Alimentación
                                    </Text>
                                    <p className="text-body text-body--l mb-4">
                                        {dataBridle.data[0]?.FEEDING}
                                    </p>
                                </TwoColumn.Left>
                                {dataBridle.data[0]?.PRODUCT_IMAGE ?
                                    <TwoColumn.Right className="w-full min-h-[385px] md:min-h-0 relative">
                                        <Image
                                            src={dataBridle.data[0]?.PRODUCT_IMAGE}
                                            width={150}
                                            height={400}
                                            className="mx-auto"
                                            alt="Imagen trazabilidad"
                                        />
                                    </TwoColumn.Right> : undefined}
                            </TwoColumn>
                            <TwoColumn gap="gap-10 md:gap-20">
                                <TwoColumn.Left>
                                    <Text className="text-subtitle text-subtitle--l mb-8" as="h2">
                                        Consejos para disfrutar de un buen jamón
                                    </Text>
                                    <p className="text-body text-body--l mb-4">
                                        En la Escuela del Jamón de Navidul, queremos compartir
                                        contigo las 10 claves para disfrutar y hacer disfrutar de un
                                        buen jamón, de la mano de nuestro maestro en jamón.
                                    </p>
                                    <p className="text-body text-body--l mb-4">
                                        Por eso, en el vídeo te mostramos cada una de las claves,
                                        desde tener un jamón Navidul a mano, hasta como conseguir el
                                        corte perfecto y disfrutarlo en compañia.
                                    </p>
                                </TwoColumn.Left>

                                <TwoColumn.Right className="w-full min-h-[385px] md:min-h-0 relative">
                                    <div className="aspect-w-16 aspect-h-9" />
                                </TwoColumn.Right>
                            </TwoColumn>
                        </TabGroup>
                    </Container>
                )}
                <TraceabilityWithModule
                    backgroundColor="bg-primary-50"
                    backgroundColor2="bg-bg-quinary"
                    description="¡Valora nuestro producto y recibirás un código de descuento del 10% de descuento para tu próxima compra online!"
                    padding="pt-[0px] px-[16px] pb-[40px] md:px-[72px] md:pb-[10px]"
                    title="Valora tu producto"
                    colorText="light"
                >
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        onClick={() => setPopUp(true)}
                        disabled={!activoValoracion}
                    >
                        VALORAR
                    </Button>
                </TraceabilityWithModule>

                <Container wrapper>
                    <ProductBlockShopify
                        shopifyCategory="destacados"
                        shopifyProducts={products}
                        title="Te puede interesar"
                    />
                </Container>
                <Modal
                    isOpen={popUp}
                    closeModal={() => setPopUp(false)}
                    className="!p-0 md:w-4/5"
                >
                    <Rating
                        descriptionLeft="¡Valora nuestro producto y recibirás un código de descuento del 10% de descuento para tu próxima compra online!"
                        textAreaText="Escribe tu opinión (opcional)"
                        textButtonStepper="continuar"
                        titleLeft="Valora tu producto"
                        titleRight="Rellenalo con tus datos y envía tu valoración"
                        setModal={setPopUp}
                        bridle={bridle}
                        setPublicado={setValorado}
                    />
                </Modal>
            </Layout >
        </>
    )
}


